// extracted by mini-css-extract-plugin
export var heroImage = "_mb-1";
export var modal = "_mb-0";